import { REGIONS } from 'config'
import { pathToRegexp } from 'path-to-regexp'

export const GTM_ID = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID

export const pageview = (url: string, refUrl: string) => {
  const regexp = pathToRegexp('/:lang/:country/(.*)?')
  const urlObj = new URL(url)
  const params = regexp.exec(urlObj.pathname.split('?')[0])

  const dataLayerEvent: { [key: string]: any } = {
    event: 'pageview',
    pageTitle: document.title,
    pagePath: url,
    pageLanguage: params && params[1],
    pageMarket: params && params[2],
    pageRegion:
      REGIONS.find((region) =>
        region.countries.find(
          (x) => params && x.code.toLowerCase() == params[2],
        ),
      )?.name ?? '',
  }

  if (refUrl) {
    dataLayerEvent.pageOldPath = refUrl
  }

  window.dataLayer?.push(dataLayerEvent)
}
